import { ResourceState } from '../types';

import { DEFAULT_ROWS_PER_PAGE } from 'app/constants/paginate';

export const initialResourceState: ResourceState = {
  totalRecordCount: 0,
  limit: DEFAULT_ROWS_PER_PAGE,
  pageIndex: 0,
};
